export interface IImage {
  source_url: string
  alt?: string
  resized?: string
}

export const imgUrl = (image: IImage | null | undefined): string => {
  if (!image) return ''
  return (process.env.REACT_APP_FILE_URL ?? '') + (image.resized || image.source_url)
}
